import React from "react";

const Details = () => {
  return <p>purchase Details</p>;
};

export default Details;
